import React, { createContext, useContext } from 'react';
import TransactionService from '../transaction.service';

export const TransactionServiceContext = createContext();

export const TransactionServiceProvider = ({ children }) => {
  return (
    <TransactionServiceContext.Provider value={TransactionService}>
      {children}
    </TransactionServiceContext.Provider>
  );
};

export const useTransactionService = () => {
  const context = useContext(TransactionServiceContext);
  if (context === undefined) {
    throw new Error('useTransactionService must be used within a TransactionServiceProvider');
  }
  return context;
};
